<template>
  <router-link v-if="access.can('follow-up-types.view')" to="/follow-up-types" class="module-link">
    <i class="pi pi-list-check"></i><span>أنواع المتابعة الدورية</span>
  </router-link>
</template>

<script>
import { useFollowUpAccessStore } from '@/stores/useFollowUpAccessStore';
export default {
  setup() { return { access: useFollowUpAccessStore() }; },
  mounted() { this.access.fetch().catch(() => {}); },
};
</script>
